import { EditorSelectionChangeParams } from 'primereact/editor';
import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { IControlProps, MapProps } from '.';
import { Editor } from '../prime';
import styles from './index.module.scss';

export interface IEditorButtonValue {
  codigo: string;
  icon?: string;
  action: (text:string, selIndex: number, selLength: number) => string;
}

interface IProps extends IControlProps<string> {
  storage?: IDataStorage;

 /** Lista de valores */
  values?: IEditorButtonValue[];

  /** Largo máximo permitido */
  headerTemplate?: React.ReactNode;
  maxLength?: number;
  /** Verifica que el contenido sea un email válido */
  height?: number;

  /** class para el TextBox */
  inputClassName?: string;
  /** estilo para el TextBox */
  inputStyle?: React.CSSProperties;
  
}

interface IState extends IControlProps<string> {
  storage?: IDataStorage;

  headerTemplate?: React.ReactNode;
  maxLength?: number;
  height?: number;

  inputClassName?: string;
  inputStyle?: React.CSSProperties;

  /** Indica el mensaje de error si es que existe */
  validError?: string;

  values?: IEditorButtonValue[];

  selectionEditor?: EditorSelectionChangeParams;
}

class Index extends React.Component<IProps, IState> {
  Editor: Editor | null = null;

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.headerTemplate !== s?.headerTemplate) res.headerTemplate = p.headerTemplate;
    if (p?.maxLength !== s?.maxLength) res.maxLength = p.maxLength;
    if (p?.height !== s?.height) res.height = p.height;
    if (p?.inputClassName !== s?.inputClassName) res.inputClassName = p.inputClassName;
    if (p?.inputStyle !== s?.inputStyle) res.inputStyle = p.inputStyle;
    if (p?.values !== s?.values) res.values = p.values;
    
    return MapProps(res, p, s);
  }

  render() {
    const { validError } = this.state;
    
    if ((this.state.values ?? []).length > 0 && $("button.ql-cnet-customs").length < 1) {
      let buttons = "";
      (this.state.values ?? []).forEach(btn => {
        buttons += `<button class="ql-cnet-customs" style="color:darkblue" data="${btn.codigo}"><i class="${btn.icon}"></i></button>`
      });
      $("div.p-editor-toolbar").append(`<span class="ql-formats">${buttons}</span>`);

      $("button.ql-cnet-customs").click(e => {
        const data = $(e.target).attr("data") ?? $(e.target).parent().attr("data");
        const newtext = this.state.values?.find(p => p.codigo === data)?.action(this.state.value ?? "", this.state.selectionEditor?.range.index ?? 0, this.state.selectionEditor?.range.length ?? 0)
        this.change(newtext);
      })
    }

    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
         {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>} 
          <Editor 
            ref={e => this.Editor = e}
            readOnly={this.state.disabled}
            value = {this.state.value} 
            onTextChange={(e) => !this.state.disabled && this.change((e.htmlValue as any))}
            style={{ ...{ height: this.state.height }, ...this.state.inputStyle }}
            onSelectionChange={e => this.setState({ selectionEditor: e })}
            headerTemplate={this.state.headerTemplate}
          />
      </div>
    );
  }

  change = (value?: string) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: string) : string | undefined => {
    const { required } = this.state;

    if (required && (value?.length ?? 0) < 1) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
